<template>
  <div
    class="d-flex flex-column"
  >
    <div class="mb-2 mention texte-gris-fonce">
      {{ libelle }}
    </div>
    <div v-if="!isLock && hasErreurSaisie && !hasSameValue">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-text-field
            ref="value"
            type="number"
            dense
            class="align-center"
            :value="valueModifiable"
            outlined
            rounded
            disabled
            hide-spin-buttons
            :rules="[rules.min, rules.max]"
            v-on="on"
            @input="updateValue($event)"
          >
            <template v-slot:prepend-inner>
              <v-icon
                color="primary"
                disabled
                @click="decrement"
              >
                mdi-minus
              </v-icon>
            </template>
            <template v-slot:append>
              <v-tooltip
                v-if="msgInfoMaisGrain"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="icon"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ msgInfoMaisGrain }}
              </v-tooltip>
              <div class="intro text-gris-fonce">
                {{ unite }}
              </div>
              <v-icon
                color="primary"
                disabled
                @click="increment"
              >
                mdi-plus
              </v-icon>
            </template>
          </v-text-field>
        </template>
        Veuillez corriger l'erreur avant de continuer votre saisie
      </v-tooltip>
    </div>
    <div v-if="!isLock && hasSameValue">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-text-field
            ref="value"
            type="number"
            class="align-center"
            :value="valueModifiable"
            outlined
            rounded
            dense
            disabled
            hide-spin-buttons
            :rules="[rules.min, rules.max]"
            v-on="on"
            @input="updateValue($event)"
          >
            <template v-slot:prepend-inner>
              <v-icon
                color="primary"
                disabled
                @click="decrement"
              >
                mdi-minus
              </v-icon>
            </template>
            <template v-slot:append>
              <v-tooltip
                v-if="msgInfoMaisGrain"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="icon"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ msgInfoMaisGrain }}
              </v-tooltip>
              <div class="intro text-gris-fonce">
                {{ unite }}
              </div>
              <v-icon
                color="primary"
                disabled
                @click="increment"
              >
                mdi-plus
              </v-icon>
            </template>
          </v-text-field>
        </template>
        Donnée non modifiable
      </v-tooltip>
    </div>
    <v-text-field
      v-if="!isLock && !hasErreurSaisie && !hasSameValue"
      ref="value"
      type="number"
      class="align-center"
      :value="valueModifiable"
      outlined
      dense
      rounded
      :disabled="isDisabled"
      hide-spin-buttons
      :rules="[rules.min, rules.max]"
      @input="updateValue($event)"
    >
      <template v-slot:prepend-inner>
        <v-icon
          color="primary"
          :disabled="valueModifiable<=0 || isDisabled"
          @click="decrement"
        >
          mdi-minus
        </v-icon>
      </template>
      <template v-slot:append>
        <v-tooltip
          v-if="msgInfoMaisGrain"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon
              class="icon"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          {{ msgInfoMaisGrain }}
        </v-tooltip>
        <div class="intro text-gris-fonce">
          {{ unite }}
        </div>
        <v-icon
          color="primary"
          :disabled="isDisabled"
          @click="increment"
        >
          mdi-plus
        </v-icon>
      </template>
    </v-text-field>
    <AgrButton
      v-if="isLock && !hasErreurSaisie"
      color="var(--gris-clair)"
      class="align-center"
      outlined
      x-large
      @click="openModalAbonnement"
    >
      <div class="d-flex justify-space-between w-100">
        <v-icon
          color="primary"
        >
          mdi-minus
        </v-icon>
        <div class="d-flex">
          <v-icon
            v-if="isLock"
            class="align-self-center"
            size="18"
            color="var(--gris-clair)"
          >
            mdi-lock
          </v-icon>
          <span class="text-gris-fonce intro padding-top">{{ valueModifiable }} {{ unite }}
            <v-tooltip
              v-if="msgInfoMaisGrain"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="pb-1"
                  size="18"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              {{ msgInfoMaisGrain }}
            </v-tooltip>
          </span>
        </div>

        <v-icon
          color="primary"
        >
          mdi-plus
        </v-icon>
      </div>
    </AgrButton>
  </div>
</template>

<script>
import {clone} from '@/utils/clone'
import { AgrButton } from '@agrial/ui'

export default {
  name: 'BaseInputNumberIncrement',
  components: {AgrButton},
  props: {
    libelle: {
      type: String,
      default: null
    },
    objectValue: {
      type: Object,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: null
    },
    unite: {
      type: String,
      default: null
    },

    msgInfoMaisGrain:{
      type: String,
      default: null
    },
    isLock: {
      type: Boolean,
      default: false
    },
    hasDroitEcriture: {
      type: Boolean,
      default: true
    },
    hasSameValue: {
      type: Boolean,
      default: false
    },
    hasErreurSaisie: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      objectModifiable: null,
      valueModifiable: null,
      rules: {
        min: v => (v !== null && v >= this.min) || 'Doit être >= ' + this.min,
        max: v => (v !== null && v <= this.max) || 'Doit être <= ' + this.max
      },
    }
  },

  watch: {
    value () {
      this.objectModifiable = clone(this.objectValue)
      this.valueModifiable = this.objectModifiable.valeur
    }
  },

  created () {
    this.objectModifiable = clone(this.objectValue)
    this.valueModifiable = this.objectModifiable.valeur
  },

  methods: {
    increment () {
      this.valueModifiable = this.valueModifiable + 1
      this.$emit('update', this.valueModifiable)
    },
    decrement () {
      this.valueModifiable = this.valueModifiable - 1
      this.$emit('update', this.valueModifiable)
    },
    updateValue (value) {
      this.valueModifiable = Number(value)
      this.$emit('update', this.valueModifiable)
    },
    openModalAbonnement () {
      this.$emit('openModalAbonnement')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-input input {
  text-align: center;
  font-family: "OpenSans", "sans-serif" !important;
  color: #646363;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
}

::v-deep.v-input--is-disabled input {
  cursor: no-drop;
}
::v-deep.v-input--is-disabled > .v-input__control > .v-input__slot {
  cursor: no-drop;
}

::v-deep.v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 8px !important;
}

::v-deep.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: #D7D8D6;
}

.padding-top {
  padding-top: 0.2rem;
}
</style>